import { Link } from "react-router-dom";

/**
 * Reuses the same route the Jobs search page uses:
 */
export const JobIdLink = ({ user_id, job_id }) => {
  if (!job_id) return <span className="text-slate-400">-</span>;

  // If we don't have a user_id we can't build the full route; show plain text.
  if (!user_id) {
    return <span className="text-sm text-slate-600">{job_id}</span>;
  }

  return (
    <Link
      to={`/jobs/details?user_id=${user_id}&job_id=${job_id}`}
      className="text-sm font-medium text-secondary-500 underline hover:cursor-pointer"
    >
      {job_id}
    </Link>
  );
};
